var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._v("please wait...")]):_c(_vm.menu,{tag:"component",attrs:{"DomainID":_vm.id,"DomainName":_vm.xhr.status.domain}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }